import { Collapse } from "@mui/material"
import { trackMenuClicks } from "common/analytics"
import NextLink from "common/bit/NextLink"
import { LinksType } from "common/SiteLinks"
import { usePathname } from "next/navigation"
import { Fragment, useEffect, useState } from "react"
import ButtonBaseBlank from "reusable/ButtonBaseBlank"
import styled from "styled-components"
import colors from "theme/colors"
import {
  HEADER_HEIGHT_D,
  HomePageContainer,
  StyledRow,
  TypographyCenter,
} from "theme/shared"

const StyledNavBar = styled.div<{ $borderBottom: boolean }>`
  /* todo only when clpase open: */
  border-top: 0.5px solid
    ${(p) =>
      p.$borderBottom ? p.theme.colors.darkGrey : p.theme.colors.transparent};
  background-color: ${(p) => p.theme.colors.headerColor};
  margin-top: ${HEADER_HEIGHT_D};
`

const StyledContainer = styled(HomePageContainer)`
  background-color: ${(p) => p.theme.colors.headerColor};
`

const StyledLinkButton = styled(ButtonBaseBlank)<{
  $selected?: boolean
  target?: string
}>`
  display: flex;
  justify-content: center;
  cursor: pointer;
  p {
    color: ${(p) =>
      p.$selected ? p.theme.colors.white : p.theme.colors.borderGrey};
    font-weight: ${(p) => (p.$selected ? "bold" : "normal")};
  }
  &:hover {
    p {
      text-decoration: underline;
    }
  }
`
const StyledRowHeader = styled(StyledRow)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

type HeaderSubCollapseProps = {
  subLinks: LinksType[] | null
}

const HeaderSubCollapse = ({ subLinks }: HeaderSubCollapseProps) => {
  const [activeLink, setActiveLink] = useState<LinksType | null>(null)

  const pathname = usePathname()

  useEffect(() => {
    if (subLinks) {
      const currentLink = subLinks.find((link) => link.link === pathname)
      setActiveLink(currentLink || null)
    }
  }, [pathname, subLinks])

  return (
    <StyledNavBar $borderBottom={(subLinks?.length ?? 0) > 0}>
      <StyledContainer>
        <Collapse
          in={(subLinks?.length ?? 0) > 0}
          timeout={"auto"}
          unmountOnExit
        >
          <StyledRowHeader
            $gap="16px"
            $notCenter
            $fullWidth
            $mt="18px"
            $mb="18px"
          >
            {subLinks?.map((item, i) => (
              <Fragment key={i}>
                <NextLink href={item.link}>
                  <StyledLinkButton
                    target={item.blank ? "_blank" : undefined}
                    onClick={() => {
                      setActiveLink(item)
                      trackMenuClicks()
                    }}
                    $selected={item === activeLink}
                  >
                    <TypographyCenter
                      variant="body1"
                      $color={colors.borderGrey}
                    >
                      {item.title}
                    </TypographyCenter>
                  </StyledLinkButton>
                </NextLink>
                {i !== subLinks.length - 1 && (
                  <TypographyCenter variant="body1" $color={colors.darkGrey}>
                    |
                  </TypographyCenter>
                )}
              </Fragment>
            ))}
          </StyledRowHeader>
        </Collapse>
      </StyledContainer>
    </StyledNavBar>
  )
}

export default HeaderSubCollapse
